import React, { useEffect, useState } from 'react';
import CustomModal from './CustomModal';
import {
  Alert,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
  DropdownItem,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
} from 'reactstrap';
import MultiInput from './MultiInput';
import utils from '../lib/utils';
import { useSelector } from 'react-redux';
import { useUnifiedFetch, useUnifiedMutate } from '../hooks';
import { myEpikBaseURL } from '../lib/api/api';
import { getEpikBoxData, selectBoxDetailsAta, selectBoxDetailsPort } from '../actions/EpikBoxes';
import { changeAction as changeActionBox } from '../actions/BoxSessionLogging';
import { useDispatch } from 'react-redux';

export default function({ onClose, isOpen }) {
  const user = useSelector(state => state.AppState.user);
  const dispatch = useDispatch();
  const token = localStorage.getItem('jwtToken');
  const selectedPort = useSelector(state => state.UIState.epikBoxDetails.selectedPort);
  let selectedObi = useSelector(state => state.UIState.epikBoxDetails.selectedObi);
  const boxDetails = useSelector(state => state.AppState.boxDetails.box);
  // const disabledAdmin = user.role === 'admin' || user.role === 'enterpriseAdmin';
  const [state, setState] = useState({ emails: [], numbers: [], file: null });
  const { isLoading: saveLoading, results, mutate, error: mutateError } = useUnifiedMutate(true);
  
  if (!selectedObi) {
    selectedObi = boxDetails.Obis.find(obi => {
      return (
        (obi.port1 && obi.port1.boxPortNumber === selectedPort.boxPortNumber) ||
        (obi.port2 && obi.port2.boxPortNumber === selectedPort.boxPortNumber)
      );
    });
  }

  const { error, isLoading, fetchData, data } = useUnifiedFetch(
    `voicemails/${selectedObi?._id}/${selectedPort?.portKey}/vmailbox`,
    true,
    true,
  );
  useEffect(() => {
    if (data && data.success && data.data) {
      const { notificationEmails, notificationNumbers, greeting } = data.data;
      setState({
        emails: notificationEmails,
        numbers: notificationNumbers,
        file: greeting,
      });
    }
  }, [data]);
  const handleChangeUpload = async ev => {
    const { files } = ev.currentTarget;
    const file = files[0];
    console.log(file);
    setState(state => ({ ...state, file }));
  };

  const isURL = str => {
    const regex = /^\/(?:\w+\/?)*\+?\d*\.wav$/;

    return regex.test(str);
  };
  const changeAction = (key, value) => {
    setState(state => ({ ...state, [key]: value }));
  };

  const onSave = async () => {
    let form = new FormData();
    if (!isURL(state.file)) {
      form.append('greeting', state.file);
      form.append('emails', state.emails);
      form.append('numbers', state.numbers);
    } else {
      form = { ...state };
    }
    const result = await mutate({
      endpoint: `voicemails/${selectedObi?._id}/${selectedPort?.portKey}/vmailbox`,
      method: 'PUT',
      body: form,
      isMyEpik: true
    });
    if (result && result.success) {
      const box = await dispatch(getEpikBoxData(token, selectedObi.assignedTo));
      const obi = box.Obis.find(obi => obi._id === selectedObi._id);
      const port = obi.port1.boxPortNumber === selectedPort.boxPortNumber ? obi.port1 : obi.port2;
      dispatch(selectBoxDetailsPort({ ...selectedPort, vmBox: port.vmBox }));
      dispatch(changeActionBox(`Voicemail settings updated for ${selectedPort?.portKey}`))
      onClose();
    }
  };
  const err = mutateError || error;
  return (
    <CustomModal
      header={'Voicemail'}
      loading={saveLoading}
      onConfirm={onSave}
      isOpen={isOpen}
      onCancel={onClose}
    >
      {typeof err === 'string' && (
        <FormGroup row className="error-text">
          <Col sm={12}>{err}</Col>
        </FormGroup>
      )}
      {isLoading && <div className="loading"></div>}
      {!isLoading && (
        <div>
          <FormGroup row>
            <Col sm={12}>
              <Label for="type" sm={12}>
                Voicemail Recording Notification email(s)
              </Label>
              <MultiInput
                inputData={state.emails}
                onChange={e => {
                  changeAction('emails', e);
                }}
                validator={utils.validateEmail}
                // disabledAdmin={disabledAdmin}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col sm={12}>
              <Label for="type" sm={12}>
                Voicemail Recording Notification SMS Text Number(s)
              </Label>
              <MultiInput
                inputData={state.numbers}
                onChange={e => {
                  const trimmedNumbers = e.map(n => n.trim());
                  changeAction('numbers', trimmedNumbers);
                }}
                // disabledAdmin={disabledAdmin}
                validator={utils.verifyPhoneNumber}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col sm={12}>
              <Label for="type" sm={12}>
                Greeting file (*.wav/.mp3 file)
              </Label>
              {state.file && (
                <>
                  <audio
                    controls
                    src={
                      isURL(state.file)
                        ? `${myEpikBaseURL}v2/voicemails/${selectedObi?._id}/${selectedPort?.portKey}/vmailbox/file?token=${token}`
                        : state.file instanceof File || state.file instanceof Blob
                        ? URL.createObjectURL(state.file)
                        : state.file
                    }
                  />
                  <p>File Name: greeting</p>
                </>
              )}
              <Input
                type="file"
                name="greetinFile"
                accept="audio/mp3,audio/wav,audio/*;"
                onChange={handleChangeUpload}
                // disabled={disabledAdmin}
              />
            </Col>
          </FormGroup>
        </div>
      )}
    </CustomModal>
  );
}
